<template>
  <ul
    class="nav nav-tabs"
    :class="{
      'border-bottom-none px-4 px-md-0': isProjectReview,
      'border-gray mb-7': isSimpleTab
    }"
  >
    <template v-if="isProjectReview">
      <li
        v-for="(obj, i) in arrObj"
        :key="obj.title"
        class="text-center reviewer-tab-list project-review-hover nav-item"
        :class="{
          'active': activeTab === i,
          'disabled-white': disabled,
          'active-green': activeTab === 0,
          'active-orange': activeTab === 1,
          'active-red': activeTab === 2,
          'active-purple': activeTab === 3,
          'active-blue': activeTab === 4
        }"
      >
        <a
          class="nav-link text-black text-left pl-3"
          :class="{
            'disabled': activeTab === i,
            'can-not-click disabled': disabled,
            'project-review-link': !disabled,
          }"
          type="button"
          @click="switchTab(i)"
        >
          <div
            v-if="!disabled"
            class="box"
            :class="{
              'green-box': i === 0,
              'orange-box': i === 1,
              'red-box': i === 2,
              'purple-box': i === 3,
              'blue-box': i === 4,
            }"
          />
          <div class="reviewer-tab">
            <span :class="{ 'ml-3': !disabled }">{{ obj.title }}</span>
            <br>
            <span class="roll-font">{{ obj.role }}</span>
          </div>
        </a>
      </li>
    </template>
    <template v-else-if="isSimpleTab">
      <li
        v-for="(obj, i) in arrObj"
        :key="obj.title"
        class="text-center simple-tab-item"
        :class="{ 'active': activeTab === i, 'company-detail-tab-width' : isCompanyDetail }"
      >
        <a
          :class="{
            'text-commit-blue': activeTab === i,
            'text-dark-gray': activeTab !== i,
            'can-not-click disabled': disabled
          }"
          :href="obj.path"
          type="button"
        >
          <span class="mr-1">
            {{ obj.title }}
          </span>
          <span
            v-if="i === 1"
            class="counter-badge counter font-extrasmall"
          >
            {{ caseStudyCounter }}
          </span>
        </a>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  props: {
    arrObj: {
      type: Array,
      default() {
        return [];
      }
    },
    activeTab: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSimpleTab: {
      type: Boolean,
      default: false
    },
    isProjectReview: {
      type: Boolean,
      default: false
    },
    caseStudiesCount: {
      type: Number,
      default: 0
    },
    isCompanyDetail: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    caseStudyCounter() {
      return this.caseStudiesCount >= 1000 ? "999+" : this.caseStudiesCount;
    }
  },
  methods: {
    switchTab(index) {
      this.$emit("switch-tab", index);
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-tabs {
  height: 52px;
  border-bottom: 2px solid #0080fc;
  &.border-bottom-none {
    border-bottom: 0px !important;
  }
  &.border-gray {
    border-bottom: 1px solid #DBDEE1 !important;
  }
}
.nav-item {
  position: relative;
  background-color: #ffffff;
  border-bottom: none;
  border-radius: 3px 3px 0 0;
  height: 50px;
  margin-right: 1rem;
  width: 180px;
  transition: background-color 0.15s ease-in-out;
  &.reviewer-tab-list {
    margin-right: 15px;
    width: 160px;
    bottom: -2px;
  }
  &.border-blue {
    border: 1px solid #65b1fc;
  }
  &:last-child {
    margin-right: 0;
  }
  &:not(.active):hover {
    background-color: #f7f8fa;
    opacity: 1;
    &.project-review-hover {
      background-color: #ffffff;
      opacity: 0.5;
    }
  }
  &.active {
    background-color: #65b1fc;
    &.active-green {
      background-color: rgba(24, 189, 134, 0.4);
    }
    &.active-orange {
      background-color: rgba(255, 147, 48, 0.4);
    }
    &.active-red {
      background-color: rgba(250, 83, 72, 0.4);
    }
    &.active-purple {
      background-color: rgba(85, 119, 238, 0.4);
    }
    &.active-blue {
      background-color: rgba(101, 177, 252, 0.4);
    }
  }
}
.nav-link {
  position: absolute; // HACK:Bootstrapに書き換える
  width: 100%;
  padding-right: 0.5rem; // HACK:remは小数点になったりであまりよろしくないので、新規では使わないようにする
  padding-left: 0.5rem;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
  border: 0;
  &.project-review-link {
    top: 42%;
  }
}
.simple-tab-item {
  min-width: 70px;
  transition: background-color 0.15s ease-in-out;
  height: 100%;
  &:not(.active):not(.bg-gray01):hover {
    opacity: 0.6;
  }
  &.active {
    font-weight: bold;
    border-bottom: 3px solid #0080FC;
  }
  a {
    display: block;
    height: 49px;
    padding: 14px;
  }
}
.company-detail-tab-width {
  min-width: 124px;
  @media (max-width: 767px) {
    width: 50%;
  }
}
.counter-badge {
  background-color: #DBDEE1;
  color: #5F6976;
  min-width: 21px;
  height: 16px;
  padding: 0 7px;
  text-align: center;
  line-height: 15px;
  border-radius: 10px;
}
@media (max-width: 767px) {
  .nav-tabs {
    .tabs-wrapper {
      width: 100%;
    }
    .nav-item {
      flex: 1;
      margin-right: 0.5rem;
    }
  }
}
.box {
  width: 10px;
  height: 10px;
  border-radius: 1px;
  margin: auto;
  position: relative;
  top: 15px;
  left: -67px;
}
.green-box {
  background: #18bd86;
}
.orange-box {
  background: #ff9330;
}
.red-box {
  background: #fa5348;
}
.purple-box {
  background: #5577ee;
}
.blue-box {
  background: #65b1fc;
}
.disabled-white {
  background-color: #ffffff !important;
}
.roll-font {
  font-size: 11px;
}
.reviewer-tab {
  line-height: 17px;
}
</style>
